import { IEDate, uGetDateFormat } from '@/modules/@appbase/util';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
})
export default class DatetimeField extends Vue {
    @Prop ({ type: String }) displayName!: string;
    @Prop({ type: String }) fieldValue!: string;

    mDisplayValue: string = "";

    created() {
        if(this.fieldValue != null && this.fieldValue.length > 0) {
            var dateValue = IEDate(this.fieldValue);

            this.mDisplayValue = uGetDateFormat('yyyy년 MM월 dd일', dateValue);
        }    
    }
}